module.exports = __webpack_public_path__ + "ca2edc7750f6f4fc1bc2067caf96e0b8.pdf";